import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { cbHomeMenuComponent } from 'app/layout/components-common/home-menu-cb/home-menu-cb.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        cbHomeMenuComponent
    ],
    imports: [
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        CommonModule,
        RouterModule
    ],
    exports     : [
        cbHomeMenuComponent
    ]
})
export class cbHomeMenuModule
{
}
